import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/apd-surveilans";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

// Master
const getJenis = () => handle(http.getData(`${BASE}/jenis`));
const getTindakan = () => handle(http.getData(`${BASE}/tindakan`));
const getMatrix = (params?: any) =>
  handle(http.getDataParam(`${BASE}/matrix`, params));
const getMatrixForTindakan = (tindakanId: number) =>
  handle(http.getData(`${BASE}/matrix/tindakan/${tindakanId}`));
const updateMatrix = (rows: any[]) =>
  handle(http.putData(`${BASE}/matrix`, { rows }));

// Sessions
const getList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/sessions`, params));
const find = (id: number) => handle(http.getData(`${BASE}/sessions/${id}`));
const create = (data: any) => handle(http.postData(`${BASE}/sessions`, data));
const update = (id: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${id}`, data));
const destroy = (id: number) =>
  handle(http.deleteData(`${BASE}/sessions/${id}`));

// Observasi
const bulkObservasi = (sessionId: number, observasi: any[]) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/observasi/bulk`, { observasi }));
const updateObservasi = (sessionId: number, observasiId: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/observasi/${observasiId}`, data));
const destroyObservasi = (
  sessionId: number,
  observasiId: number,
  alasan: string
) =>
  handle(
    http.deleteDataParam(`${BASE}/sessions/${sessionId}/observasi/${observasiId}`, {
      data: { alasan_hapus: alasan },
    })
  );

// Sign (4-tier)
const submitAuditor = (id: number, data: any) =>
  handle(http.postData(`${BASE}/sessions/${id}/submit-auditor`, data));
const approveKaunit = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-kaunit`, data));
const approveKomitePpi = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-komite-ppi`, data));
const approvePimpinan = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/approve-pimpinan`, data));

// Temuan
const storeTemuan = (sessionId: number, data: any) =>
  handle(http.postData(`${BASE}/sessions/${sessionId}/temuan`, data));
const updateTemuan = (sessionId: number, temuanId: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`, data));
const destroyTemuan = (sessionId: number, temuanId: number) =>
  handle(http.deleteData(`${BASE}/sessions/${sessionId}/temuan/${temuanId}`));
const getTemuanTerbuka = (params?: any) =>
  handle(http.getDataParam(`${BASE}/temuan-terbuka`, params));

// Dashboard
const getDashboard = (params?: any) =>
  handle(http.getDataParam(`${BASE}/dashboard`, params));
const getComplianceForUnit = (unitId: string) =>
  handle(http.getData(`${BASE}/compliance-for-unit/${unitId}`));

// PDF
const printPdf = (id: number) => {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
};

export default {
  getJenis,
  getTindakan,
  getMatrix,
  getMatrixForTindakan,
  updateMatrix,
  getList,
  find,
  create,
  update,
  destroy,
  bulkObservasi,
  updateObservasi,
  destroyObservasi,
  submitAuditor,
  approveKaunit,
  approveKomitePpi,
  approvePimpinan,
  storeTemuan,
  updateTemuan,
  destroyTemuan,
  getTemuanTerbuka,
  getDashboard,
  getComplianceForUnit,
  printPdf,
};
